import React from 'react';
import { IconButton, Slide, Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import NextLink from 'next/link';
import PropTypes from 'prop-types';

import useResponsive from '../../../utils/responsive';
import { Image } from '../shared';

const CustomTransition = React.forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />;
});

CustomTransition.displayName = 'Transition';

const FullScreenDialog = (props) => {
    const { isOpen, setIsOpen, Stepper, children } = props;
    const { isMobile, isTablet } = useResponsive();
    const split = isMobile || isTablet;
    const handleClose = () => {
        setIsOpen(false);
    };

    return (

        <Dialog fullScreen disableEnforceFocus open={isOpen} slots={{ transition: CustomTransition }} id="gallery-dialog">

            <div className={`full-screen-dialog-container ${ split ? 'full-screen-dialog-container-split' : 'full-screen-dialog-container-no-split'}`}>

                {split && (

                    <div className='full-screen-dialog-header-container'>

                        <div className='full-screen-dialog-header'>

                            <NextLink href="/">

                                <div className='full-screen-dialog-logo-image-container'>

                                    <Image
                                        src="/assets/images/homii_logo.png"
                                        alt="HOMii Logo"
                                        id="homii-logo-link"
                                        height={22}
                                        width={82.25}
                                    />

                                </div>

                            </NextLink>

                            <IconButton id="full-screen-dialog-close-button" className='full-screen-dialog-close-button' disableRipple aria-label="close" onClick={handleClose}>

                                <CloseIcon className='full-screen-dialog-close-icon' />

                            </IconButton>

                        </div>

                        <Divider className='full-screen-dialog-divider' />

                        <div className='full-screen-dialog-app-bar-content-wrapper'>

                            <div className='full-screen-dialog-app-bar-content-container'>{Stepper}</div>

                        </div>

                    </div>

                )}

                {!split && (

                    <div className="full-screen-dialog-app-bar full-screen-app-bar">

                        <NextLink href="/">

                            <div className='full-screen-dialog-logo-image-container'>

                                <Image
                                    id="homii-logo-link"
                                    src="/assets/images/homii_logo.png"
                                    alt="HOMii Logo"
                                    height={22}
                                    width={82.25}
                                />

                            </div>

                        </NextLink>

                        <div className='full-screen-dialog-app-bar-content-container'>{Stepper}</div>

                        <IconButton className='full-screen-dialog-close-button' disableRipple aria-label="close" onClick={handleClose}>

                            <CloseIcon className='full-screen-dialog-close-icon' />

                        </IconButton>

                    </div>

                )}

                {children}

            </div>

        </Dialog>
    );
};

export default FullScreenDialog;

FullScreenDialog.propTypes = {
    isOpen: PropTypes.bool,
    Stepper: PropTypes.object,
    children: PropTypes.any,

    setIsOpen: PropTypes.func,
};

